import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Vector3 } from 'three';
import { GrayImage3 } from '../../image-slice-show/share/image';
import { b64ToFloat32Array } from '../utils';

function readFile(
  file: Blob,
  parser: (reader: FileReader, file: Blob) => void,
): Observable<string> {
  return new Observable(function(observer) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      observer.next(e.target.result);
    };
    reader.onabort = (e) => {
      observer.error(e);
    };
    reader.onerror = (e) => {
      observer.error(e);
    };
    reader.onloadend = () => {
      observer.complete();
    };
    parser(reader, file);
  });
}

export interface ImageHead {
  shape: Vector3;
  size: Vector3;
}

@Injectable()
export class LocalImageLoaderService {
  constructor() {}
  loadHead(file: Blob): Observable<ImageHead> {
    return readFile(file, (reader, f) => {
      reader.readAsText(f);
    }).pipe(
      map((t) => JSON.parse(t)),
      map((r) => {
        return { shape: r.shape, size: r.size };
      }),
      tap((x) => console.log(x)),
    );
  }
  loadImage(
    file: Blob,
    head: ImageHead,
    center: Vector3 = new Vector3(0, 0, 0),
  ): Observable<GrayImage3> {
    return readFile(file, (reader, f) => {
      reader.readAsBinaryString(f);
    }).pipe(
      map(b64ToFloat32Array),
      map((data) => new GrayImage3(center, head.size, head.shape, data)),
    );
  }
}
